export const parseMatchDuration = (value) => {
  const text = String(value ?? "").trim();
  if (!/^\d+$/.test(text)) return null;

  const minutes = Number(text);
  return Number.isSafeInteger(minutes) && minutes >= 1 && minutes <= 1440 ? minutes : null;
};
